import * as types from './types';
import { AuthService } from '../services/auth.service';
import { RoyaltyService } from '../services/royalty.service';
import { HomeService } from '../services/home.service'
import router from '../../../router';
import { NotificationService } from '../../../dt-plugins/notification/notification.service';
import { isoCountries } from '../models/iso-countries'
import { FixedProperties } from '../models/Fixed-Properties'
import * as D from 'date-fns';
export const actions = {
  async [types.B2B_LOGIN]({ commit, getters }, payload) {
    AuthService.login(getters.loginUser).then(res => {
      AuthService.fetchUserDetails().then(res => {
        if (res.data.user.first_login == 1) {
          router.push({
            name: FixedProperties.HOME_TITLE,
            query: {
              modal: 'change_password',
            }
          })
        }
        else {
          router.push({
            name: FixedProperties.HOME_TITLE,
          })
        }

        commit(types.B2B_SET_LOGIN_REDIRECT_ROUTE, { name: 'b2b' });
        setTimeout(() => {
          commit(types.B2B_SET_LOGIN_USER, {
            username: '',
            password: ''
          })

        }, 5000)
      })
    }).catch(e => {

      commit(types.B2B_SET_LOGIN_USER, {
        username: '',
        password: ''
      });
      NotificationService.showNotification({
        text: 'Username or password is incorrect',
        timeout: 5000,
        color: 'error'
      });
      if (router.currentRoute.name !== 'b2bLogin') {
        router.push({
          name: "b2bLogin",
        })
      }


    })

  },

  async [types.B2B_SET_LOGIN_REDIRECT_ROUTE]({ commit }, payload) {
    commit(types.B2B_SET_LOGIN_REDIRECT_ROUTE, payload);
  },
  async [types.B2B_IS_LOGGED_IN]({ commit, getters }, payload) {
    AuthService.isLoggedIn().then(res => {
      let isLoggedIn = false;
      if (!res) {
        isLoggedIn = false
        router.push({
          name: "b2bLogin",
        })
      }
      else {
        isLoggedIn = true;

      }
      commit(types.B2B_SET_IS_LOGGED_IN, isLoggedIn);

    }).catch(e => {
      console.log(e)
      commit(types.B2B_SET_IS_LOGGED_IN, false);
      commit(types.B2B_SET_LOGIN_USER, {
        username: '',
        password: ''
      })
      router.push({
        name: "b2bLogin",

      })
    })

  },

  async [types.B2B_LOGGED_OUT]({ commit }) {
    AuthService.logOut().then(result => {
      commit(types.B2B_SET_IS_LOGGED_IN, false);
      commit(types.B2B_SET_LOGIN_USER, {
        username: '',
        password: ''
      })
      router.push({
        name: "b2bLogin",
      })
    });

  },
  async [types.B2B_FETCH_USER_DETAILS]({ commit, state, dispatch }) {
    let userDetails = await AuthService.fetchUserDetails().catch(e => {
      commit(types.B2B_SET_IS_LOGGED_IN, false);
      commit(types.B2B_SET_LOGIN_USER, {
        username: '',
        password: ''
      })
      router.push({
        name: "b2bLogin",
      });
      throw error;
    })
    if (userDetails) {
      let isLoggedIn = false;
      userDetails.data.user.given_name = !userDetails.data.user.given_name || userDetails.data.user.given_name == "" ? userDetails.data.user.user_name : userDetails.data.user.given_name;
      if (userDetails.data.user && userDetails.data.user.active == '1') {
        isLoggedIn = true;

      }
      else {
        isLoggedIn = false
        router.push({
          name: "b2bLogin",
        })
        return
      }
      const user = {
        ...userDetails.data.user,
        system_currency: userDetails.data.system_currency,
        ext_api_details: userDetails.data.ext_api_details,
        ext_api_checksum:userDetails.data.ext_api_details.checksum
      }
      window.b2b_default_currency = userDetails.data.system_currency;
      commit(types.B2B_SET_IS_LOGGED_IN, isLoggedIn);
      commit(types.B2B_SET_USER, user);
      commit(types.B2B_SET_USER_DETAILS, user);
    }
  },
  async [types.B2B_RESET_PASSWORD]({ state, getters, commit }) {

    AuthService.resetPassword(getters.resetPassword).then(result => {
      if (result) {
        const data = result.data.found == 0 ? false : true
        commit(types.B2B_SET_RESULT_RESET_PASSWORD, data);
      }
    })
  },
  async [types.B2B_UPDATE_USER_INFO]({ state, getters, commit }) {
    await AuthService.updateUserInfo(getters.userInfo)
  },
  async [types.B2B_FETCH_USER_INFO]({ state, getters, commit }) {
    let userInfo = await AuthService.fetchUserInfo(getters.userDetails.external_user_id);
    if (userInfo) {
      userInfo.data.user.reset_pw_url = userInfo.data.reset_pw_url;
      userInfo.data.user.given_name = !userInfo.data.user.given_name || userInfo.data.user.given_name == "" ? userInfo.data.user.user_name : userInfo.data.user.given_name;
      commit(types.B2B_SET_USER_INFO, userInfo.data.user);
    }
  },
  async [types.B2B_FETCH_LANGUAGES]({ state, getters, commit }) {
    let languages = await AuthService.fetchLanguages();
    if (languages) {
      commit(types.B2B_SET_LANGUAGES, languages.data.languages);
    }
  },
  async [types.B2B_FETCH_ROYALTY_YEARS]({ commit, state, dispatch }) {
    let royaltyYears = await RoyaltyService.getRoyaltyYears(state.user.external_user_id);
    if (royaltyYears) {
      let years = royaltyYears.data.years.map(y => {
        return {
          title: y.year, route: y.year, parent: FixedProperties.ROYALTY_ACCOUNT_ROUTE,
          img: 'static/icons/b2b/label-inactive.svg',
          children: []
        }
      })
      commit(types.B2B_SET_ROYALTY_YEARS, years);
    }

  },


  async [types.B2B_FETCH_ROYALTIES_BY_YEAR]({ commit, state }) {
    const year = state.activeSubRouteItem.route;
    commit(types.B2B_SET_LOADED_DATA, true);
    commit(types.B2B_SET_LOADED_DATA_TEXT, 'Loading....');
    commit(types.B2B_SET_ROYALTIES_BY_YEAR, []);
    const data = await RoyaltyService.getRoyaltiesByYear(year, state.user.external_user_id);
    //data.data.royalties = [];
    if (data) {
      if (data.data.royalties && data.data.royalties.length > 0) {
        data.data.royalties.forEach((r, index) => {
          r.created = r.created ? D.format(r.created, 'YYYY-MM-DD') : '';
        })

      }
      commit(types.B2B_SET_ROYALTIES_BY_YEAR, data.data.royalties);
      commit(types.B2B_SET_ROYALTY_PAGE_CHART, {
        report_country_digital: data.data.report_country_digital,
        report_shop_digital: data.data.report_shop_digital,
        report_country_physical: data.data.report_country_physical,
        report_release: data.data.report_release,
        report_channel: data.data.report_channel
      });

      commit(types.B2B_SET_IS_LOADED_ROYALTY_PAGE_DATA, true);
      commit(types.B2B_SET_HAS_CREDIT_NOTE, data.data.has_credit_note > 0 ? true : false);
    }
    commit(types.B2B_SET_LOADED_DATA, false);
    commit(types.B2B_SET_LOADED_DATA_TEXT, 'No Data Available');
    return data.data.royalties


  },
  async [types.B2B_FETCH_FILTERED_CHANNEL_CHART]({ commit, state, dispatch }, payload) {
    const search_key = payload;
    commit(types.B2B_SET_CHANNEL_LOADED_DATA, false);
    let charts = await HomeService.getFilteredChannelCharts(state.user.external_user_id, search_key);
    if (charts) {
      commit(types.B2B_SET_FILTERED_CHANNEL_CHART, charts.data.report_data);
      commit(types.B2B_SET_CHANNEL_LOADED_DATA, true);
    }


  },

  async [types.B2B_FETCH_HOME_PAGE_CHART]({ commit, state, dispatch }) {
    let homepage = await HomeService.getHomePageCharts(state.user.external_user_id);
    if (homepage) {
      commit(types.B2B_SET_HOME_PAGE_CHART, homepage.data);
      commit(types.B2B_SET_IS_LOADED_HOME_PAGE_DATA, true);
    }


  },


}

export function country2emoji(country_code) {
  var OFFSET = 127397;
  var cc = country_code.toUpperCase();
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  return /^[A-Z]{2}$/.test(cc) ? String.fromCodePoint.apply(String, _toConsumableArray([].concat(_toConsumableArray(cc)).map(function (c) {
    return c.charCodeAt() + OFFSET;
  }))) : null;
}
